"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Media } from "@opensea/ui-kit";
import { useDropStore } from "@/components/collection/drops/components/CollectionDropContext";
import { DropStatus } from "@/components/collection/drops/constants";
import { HeroHeaderFullLayout } from "@/components/hero-header/HeroHeaderFullLayout";
import { CollectionMetadataChips } from "../CollectionMetadataChips";
import { CollectionMetadataChipsFragment } from "../CollectionMetadataChips/CollectionMetadataChips.fragment";
import { CollectionHeaderDropCountdown } from "./CollectionHeaderDropCountdown";
import { CollectionHeaderLayoutGroup, CollectionHeaderLayoutGroupFragment } from "./CollectionHeaderLayoutGroup";
import { CollectionInfo, CollectionInfoFragment } from "./CollectionInfo";
import { CollectionHeaderStats, CollectionHeaderStatsFragment } from "./CollectionStats";
export const CollectionHeaderFullContentFragment = graphql(`
    fragment CollectionHeaderFullContent on Collection {
      ...CollectionInfo
      ...CollectionMetadataChips
      ...CollectionHeaderStats
      ...CollectionHeaderLayoutGroup
    }
  `, [CollectionHeaderLayoutGroupFragment, CollectionInfoFragment, CollectionMetadataChipsFragment, CollectionHeaderStatsFragment]);
export function CollectionHeaderFullContent(t0) {
  const $ = _c(21);
  const {
    collection: collectionKey
  } = t0;
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(CollectionHeaderFullContentFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  const status = useDropStore(_temp);
  let t2;
  if ($[2] !== collection || $[3] !== status) {
    t2 = status === DropStatus.MINTING_SOON ? <CollectionHeaderDropCountdown variant="full" /> : <CollectionHeaderStats collection={collection} />;
    $[2] = collection;
    $[3] = status;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const statsModule = t2;
  let t3;
  if ($[5] !== collection) {
    t3 = <CollectionInfo collection={collection} />;
    $[5] = collection;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== collection) {
    t4 = <Media lessThan="lg"><CollectionMetadataChips collection={collection} variant="compact" /></Media>;
    $[7] = collection;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== collection) {
    t5 = <Media greaterThanOrEqual="lg"><CollectionMetadataChips collection={collection} /></Media>;
    $[9] = collection;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== statsModule || $[15] !== t3 || $[16] !== t6) {
    t7 = <HeroHeaderFullLayout className="dark" description={null} info={t3} metadataChips={t6} showMetadataChipsOnLarge={false} stats={statsModule} />;
    $[14] = statsModule;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== collection || $[19] !== t7) {
    t8 = <CollectionHeaderLayoutGroup collection={collection}>{t7}</CollectionHeaderLayoutGroup>;
    $[18] = collection;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp(state) {
  return state.status;
}